<!-- 区域上报进度页面 -->
<template>
  <div class='areaRptSchedule'>
    <!-- <v-header :headTitle='headTitle' :isBack='true' :pageName="pageName"></v-header> -->
    <div class="container">
      <div class="area-bg">
        <div class="item flex yet-report">
          <h3>{{yetReportTotal}}</h3>
          <p>已上报合计</p>
        </div>
        <div class="item flex join">
          <h3>{{notReportTotal}}</h3>
          <p>未上报合计</p>
        </div>
      </div>
      <van-notice-bar mode="closeable" v-if="isShowNotice!='1'&&!isShowEmpty" @close='handleCloseNotice'>实时更新以下数据</van-notice-bar>
      <empty-component v-if="isShowEmpty" />
      <div class="content" v-else :style="{'margin-top':isShowNotice!='1'?'0px':'10px'}">
        <div class="content-item df-between" @click='handleJumpTo(item)' v-for='(item,index) in areaRptScheduleData' :key='index'>
          <div class="item-left df-item-center">
            <img src="../../assets/images/area.png" alt="">
            <div class="area-text">{{item.areaName}}</div>
          </div>
          <div class="item-right df-between">
            <div class="flex item-yetReport">
              <p>{{item.reportCnt}}</p>
              <span>已上报</span>
            </div>
            <div class="flex item-join">
              <p>{{item.notReportCnt}}</p>
              <span>未上报</span>
            </div>
            <img src="../../assets/images/arrow-right.png" alt="">
          </div>

        </div>
      </div>
      <van-popup v-model="isShowPopup" style='border-radius:10px;'>
        <div class="dalog-box">
          <div class="dalog-content">
            <div class="dalog-title">权限提示</div>
            <p>抱歉，您没有开通区域管理员权限，如果您是区域负责人，请与主办方联系申请开通：曾翠  0731-89753264</p>
          </div>
          <div class="line"></div>
          <div class="btn-box df-between">
            <div class="btn df-center" @click='handleBtnRight'>知道了</div>
          </div>
        </div>
      </van-popup>
      <!-- <dragIndex v-on:handleBackApp='handleBackApp'></dragIndex> -->
      
    </div>
    <!-- <v-footer></v-footer> -->

  </div>
</template>

<script>
  import footer from '../../components/footer/footer.vue'
  import header from '../../components/header/header'
  import emptyComponent from '../../components/empty-component/empty-component.vue'
  import dragIndex from './dragIndex.vue'
  import {mapState} from 'vuex'
  export default {
    data() {
      return {
        isShowEmpty: true,
        pageName: '',
        headTitle:localStorage.getItem('taskName'),
        yetReportTotal:0,
        notReportTotal:0,
        isShowPopup:false,
        isShowNotice:'0',
        areaRptScheduleData:[]
      }
    },
    components: {
      'v-footer': footer,
      dragIndex,
      'v-header': header,
      emptyComponent
    },
    computed: {
      ...mapState({
          _userInfo: (state) => state.InvestorInfo
      })
    },
    created() {
      this.isShowNotice = localStorage.getItem('isShowNotice')?localStorage.getItem('isShowNotice'):'0'
      this.initData()
    },
    methods: {
      initData(){
        let params = {
          userId: this._userInfo.data.userId,
          sub_id: "",
          comId: this._userInfo.data.comId,
          data: {
            taskId: localStorage.getItem('taskId'),
            batch: localStorage.getItem('batch')
          },
          malVersion: "A0"
        };
        this.$http.getAreaReportInfo(params).then((res) => {
          if (res.code === 0) {
            this.areaRptScheduleData = res.data
            this.areaRptScheduleData.forEach((v,i)=>{
              this.yetReportTotal += v.reportCnt
              this.notReportTotal += v.notReportCnt
            })
            if(this.areaRptScheduleData.length>0){
              this.isShowEmpty = false
            }
          } else {
            this.$toast(res.msg);
          }
        });
        
      },
      // 跳转
      handleJumpTo(val){
        if(localStorage.getItem('isManagerUser')!=1){ // 没有权限  弹窗提示
          this.isShowPopup = true
        }else{
          this.$router.push({
            path: '/areaMonitorReport',
            query: {
               taskId: localStorage.getItem('taskId'),
               batch: localStorage.getItem('batch'),
               areaCode: val.areaCode,
               reportCnt: val.reportCnt,
               notReportCnt: val.notReportCnt,
               areaName: val.areaName
            }
          })
        }
      },
      // 知道了
      handleBtnRight(){
        this.isShowPopup = false
      },
      // 返回感控工作间app
      handleBackApp(){
        this.backToApp()
      },
      // 关闭通知栏
      handleCloseNotice(){
        this.isShowNotice = '1'
        localStorage.setItem('isShowNotice','1')
      }
    },
  }
</script>
<style lang='scss' scoped>
  .flex{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  }
  .areaRptSchedule {
    // display: flex;
    // flex-direction: column;
    // height: 100vh;
    .container {
      // height: 100vh;
      // background-color: #f2f2f2;
      // overflow: scroll;
      .area-bg{
        display: flex;
        justify-content: space-around;
        background: url('../../assets/images/area-bg.png') no-repeat;
        background-size: 100%;
        .item{
          height: 87px;
          padding: 12px 0px;
          color: #ffffff;
          h3{
            font-size: 32px;
            font-family: PingFangSC, PingFangSC-Medium;
            font-weight: 500;
          }
          p{
            font-size: 12px;
          }
        }
      }
      .content{
        // margin-top: 10px;
        .content-item{
          padding: 0px 12px 0px 15px;
          margin-bottom: 5px;
          background-color: #fff;
          .item-left{
            flex: 1;
            justify-content: flex-start;
            img{
              width: 18px;
              height: 20px;
            }
            .area-text{
              margin-left: 10px;
              font-size: 16px;
              font-family: PingFangSC, PingFangSC-Medium;
              font-weight: 500;
              color: #323233;
            }
          }
          .item-right{
            flex: 1;
            font-size: 16px;
            font-family: PingFangSC, PingFangSC-Medium;
            font-weight: 500;
            .flex{
              height: 66px;
              padding: 10px 0px;
            }
            .item-yetReport{
              color: #1c91ff;
            }
            .item-join{
              color: #323233;
            }
            img{
              width: 18px;
              height: 19px;
            }
            span{
              color: #666666;
              font-size: 12px;
            }
          }


        }
      }
      .dalog-box {
        position: relative;
        width: 310px;
        background-color: #fff;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        font-size: 16px;
        border-radius: 10px;
        overflow: hidden;
        .dalog-content {
          padding: 24px;
          border-bottom: 1px solid #eee;
          .dalog-title {
            font-family: PingFangSC, PingFangSC-Medium;
            font-weight: 500;
            color: #333333;
            margin-bottom: 10px;
            text-align: center;
          }
          p {
            font-size: 14px;
            color: #666;
          }
        }
        .btn-box {
          color: #26b4ff;
          .btn {
            flex: 1;
            padding: 12px 0px;
          }
        }
      }
    }
  }
</style>